import { initSubRoutes } from '../../../../utils/router';

const RoutesEcranGestion = initSubRoutes({
    route: '/gestion',
    subroutes: {},
    nom: 'Gestion de compte',
});

export default RoutesEcranGestion;
